import { createBrowserRouter } from "react-router-dom";
import MainLayout from "../layouts/main.layout";
import Homepage from "../pages/home";
import HowItWorks from "../pages/how-it-works";
import FAQs from "../pages/faqs";
import CaseStudies from "../pages/case-studies";
import PrivacyPolicy from "../pages/privacy-policy";
import { useEffect } from "react";

const ExternalRedirect = ({ url }) => {
  useEffect(() => {
    window.location.href = url;
  }, [url]);

  return null;
};

export const router = createBrowserRouter([
  {
    path: "/",
    element: <MainLayout />,
    children: [
      {
        path: "/",
        element: <Homepage />,
      },
      {
        path: "/how-it-works",
        element: <HowItWorks />,
      },
      {
        path: "/faqs",
        element: <FAQs />,
      },
      {
        path: "/case-studies",
        element: <CaseStudies />,
      },
      {
        path: "/contact",
        element: (
          <ExternalRedirect url="https://www.eventshop.com/partner-with-us?referral=interactive-images" />
        ),
      },
      {
        path: "/digital-experience",
        element: (
          <ExternalRedirect url="https://www.eventshop.com/partner-with-us?referral=interactive-images" />
        ),
      },
      {
        path: "/privacy-policy",
        element: <PrivacyPolicy />,
      },
    ],
  },
]);
